import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { pxToRem } from '@yoweb/ui/styles/utils';
import { getRadii, getSpace, getColor, getDuration } from '@yoweb/ui/styles/utils/theme';
import { Box } from '@yoweb/ui/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * A component for visualizing the user's progress through a series of steps.
 * The steps are represented by thin grey lines that expand and darken to portray an active step.
 */
export var PaginationIndicator = function PaginationIndicator(_ref) {
  var steps = _ref.steps,
      step = _ref.step,
      onStepChange = _ref.onStepChange;

  var _useState = useState(step !== null && step !== void 0 ? step : 0),
      currentStep = _useState[0],
      setCurrentStep = _useState[1];

  var doOnStepChange = function doOnStepChange(newStep) {
    setCurrentStep(newStep);
    onStepChange === null || onStepChange === void 0 ? void 0 : onStepChange(newStep);
  };

  useEffect(function () {
    if (step !== undefined) {
      setCurrentStep(step);
    }
  }, [step]);
  return /*#__PURE__*/_jsx(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    children: Array.from({
      length: steps
    }, function (_, i) {
      return /*#__PURE__*/_jsx(IndicatorButton, {
        isActive: i === currentStep,
        onClick: function onClick() {
          return doOnStepChange(i);
        }
      }, i);
    })
  });
};
var IndicatorButton = styled.button.withConfig({
  componentId: "sc-19moa9x-0"
})(["width:", ";height:", ";border-radius:", ";margin-right:", ";background:", ";opacity:", ";cursor:pointer;transition:width ", "ms ease-out;&:last-child{margin-right:0;}"], function (_ref2) {
  var isActive = _ref2.isActive;
  return pxToRem(isActive ? 37 : 16);
}, getSpace('small2'), getRadii('small'), getSpace('small2'), getColor('charcoal'), function (_ref3) {
  var isActive = _ref3.isActive;
  return isActive ? 1 : 0.2;
}, getDuration('interaction'));